module.exports = __webpack_public_path__ + "static/media/import-doc-1.6e0655c6.svg";